/**
 * The eye button's names on every `PasswordInput` (`@tonnie/ui`), translated
 * once here so no screen spells them out.
 *
 *   <PasswordInput revealLabels={usePasswordRevealLabels()} … />
 */
import { useMemo } from 'react';

import { useTranslation } from './useTranslation';

export interface PasswordRevealLabels {
  show: string;
  hide: string;
}

export function usePasswordRevealLabels(): PasswordRevealLabels {
  const { t } = useTranslation();
  return useMemo(() => ({ show: t('auth.showPassword'), hide: t('auth.hidePassword') }), [t]);
}
